/**
 * Las líneas del detalle que el cajero anota por forma de pago al cerrar: el
 * número de voucher, el de ticket POS o la referencia bancaria, con su importe.
 *
 * Viven acá y no dentro del formulario para poder probarlas. La que motivó la
 * separación es `quitarLinea`: la tabla necesita al menos una fila para que se
 * vea dónde escribir, y eso se resolvía **ignorando el clic** cuando quedaba una
 * sola. El bote de basura quedaba muerto sin decirlo, y con una línea escrita no
 * había forma de limpiarla más que borrar los dos campos a mano.
 */

/** Una fila vacía, la que se ofrece al abrir el detalle y al vaciar la última. */
export const lineaVacia = (methodCode, indice = 0) => ({
  key: `${methodCode}-${indice}`,
  codigo: "",
  total: 0,
});

/**
 * Quita la línea indicada. Si es la última que queda, la deja vacía en vez de
 * quitarla: la tabla nunca se queda sin ninguna, pero el botón siempre hace algo.
 */
export const quitarLinea = (rows = [], index, methodCode) => {
  if (rows.length <= 1) return [lineaVacia(methodCode)];

  return rows.filter((_, i) => i !== index);
};

/** Agrega una línea vacía al final. */
export const agregarLinea = (rows = [], methodCode) => [
  ...rows,
  lineaVacia(methodCode, rows.length),
];

/** Cambia un campo de una línea, sin tocar las demás. */
export const actualizarLinea = (rows = [], index, patch) => {
  const siguientes = [...rows];
  siguientes[index] = { ...siguientes[index], ...patch };

  return siguientes;
};

/**
 * Un importe escrito a mano, en número: un campo vacío o con texto vale cero.
 *
 * Estaba definida dentro del formulario, y las líneas del detalle la
 * necesitan para sumar. Se exporta desde acá para que haya una sola.
 */
export const normalizeAmount = (value) => parseFloat(value || 0) || 0;

/** Lo que suman las líneas, que es lo que se compara contra el digitado. */
export const totalDeLineas = (rows = []) =>
  rows.reduce((suma, row) => suma + normalizeAmount(row.total), 0);
